import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { useStylesTF, useStylesLbl
} from '../../../St/Reports/UseStyle';
import { GetItemFromOptions } from "../../../services/global-services";
import CheckboxItems from "./CheckBoxComponents";
const applyDiscountOpeions = [
    { id: 1, name: " الخصم نسبه فقط" },
    { id: 2, name: "الخصم مبلغ فقط" },
    { id: 3, name: " الخصم نسبه  ومبلغ معا" },
];
export default function DiscountsPermisson(props) {
    const { object, onChange,  onChangeAuto } = props;
    const { t } = useTranslation(["forms"]);
    const claslbl = useStylesLbl();
    const clasTF = useStylesTF();
    const applyDisc = GetItemFromOptions(object?.apply_discount, applyDiscountOpeions);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                    <CheckboxItems
                        value={object["Disc_saleOnItem"] ?? null}
                        name={"Disc_saleOnItem"}
                        label={"الخصم على مستوى الصنف"}
                        onChange={onChange}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                    <CheckboxItems
                        value={object["Disc_saleOnBills"] ?? null}
                        name={"Disc_saleOnBills"}
                        label={"الخصم على مستوى الفاتوره "}
                        onChange={onChange}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>

                </Grid>

                <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Autocomplete
                        classes={clasTF}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        value={applyDisc}
                        onChange={(event, newValue) => {
                            onChange(null, {
                              name: "apply_discount",
                              value: newValue?.id,
                            });
                          }}
                        id="combo-box-demo"
                        size="small"
                        options={applyDiscountOpeions}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("نوع الخصم ")}
                                variant="outlined"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}

                            />
                        )}
                    />
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="SaleDiscPers"
                        label="نسبة الخصم المسموح Max %"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="number"
                        name="SaleDiscPers"
                        disabled={applyDisc?.id == 2 ? true : false}
                        value={object.SaleDiscPers}
                        onChange={(e) => {
                            onChange(null, {
                              name: "SaleDiscPers",
                              value: e.target.value,
                
                            });
                          }}

                    />
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="SaleDiscValue"
                        label="مبلغ الخصـم المسموح  Max "
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="number"
                        name="SaleDiscValue"
                        disabled={applyDisc?.id == 1 ? true : false}
                        value={object.SaleDiscValue}
                        onChange={(e) => {
                            onChange(null, {
                              name: "SaleDiscValue",
                              value: e.target.value,
                
                            });
                          }}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
